import { Generator } from "../../../common/generator";

import { AABBBounds, Matrix } from "@visactor/vutils";

export class BaseWindowHandlerContribution {
    constructor() {
        this._uid = Generator.GenAutoIncrementId(), this.viewBox = new AABBBounds, this.modelMatrix = new Matrix(1, 0, 0, 1, 0, 0);
    }
    onChange(cb) {
        this._onChangeCb = cb;
    }
    configure(window, global) {
        global.env === this.type && window.setWindowHandler(this);
    }
    release(...params) {
        this.releaseWindow();
    }
    isVisible(bbox) {
        return !0;
    }
    onVisibleChange(cb) {}
    getTopLeft(baseWindow) {
        return {
            top: 0,
            left: 0
        };
    }
    setViewBox(vb) {
        this.viewBox.setValue(vb.x1, vb.y1, vb.x2, vb.y2);
    }
    getViewBox() {
        return this.viewBox;
    }
    setViewBoxTransform(a, b, c, d, e, f) {
        this.modelMatrix.setValue(a, b, c, d, e, f);
    }
    getViewBoxTransform() {
        return this.modelMatrix;
    }
}
//# sourceMappingURL=base-contribution.js.map
